import { Deserializable } from '../_common/deserializable';

export class StreamHistoryReport implements Deserializable{
    day: string;
    total: number;
    success: number;
    withhold: number;
    others: number;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
